import AppGlobalSettings from "@app/AppGlobalSettings"
import { Consent } from "@ng-mw/shared-react-components/src/modules/consents/types/Consent"

export const getWhitelistByChannel = (
    consents: Consent[],
    channels: string[],
    whiteListedTypes: string[],
) => {
    return consents
        .filter(
            (consent: Consent) =>
                consent.itemType === "CONSENT" &&
                consent.chainId === AppGlobalSettings.chainId &&
                channels.includes(consent.channel) &&
                whiteListedTypes.includes(consent.type),
        )
        .map((consent: Consent) => ({
            chainId: consent.chainId,
            type: consent.type,
            channelCode: consent.channelCode,
            channel: consent.channel,
            status: consent.status === "true" ? true : false,
        }))
}
